import './legacy/more_flats_in_jk_promotion.css';
import './legacy/realtor-card.css';
import { phoneShowGaStat, IPhoneShowGaStatProducts } from './tracking';

export default function initOffer() {
  (window as any).offerPhoneShowGaStat = (type: string, offerType: string, products: IPhoneShowGaStatProducts) => {
    phoneShowGaStat(type, offerType, products);
  };
}



// WEBPACK FOOTER //
// ./src/bundles/offer/index.tsx